import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Moment from "react-moment";
import "moment/locale/pt-br";
import "./style.css";
import axios from "axios";
import { FeedPostMenu } from "../shared";
import EditPostPopup from "../../editPostPopup";

export default function ClassifiedFeed() {
  const { user } = useSelector((state) => ({ ...state }));
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState("all");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [selectedAd, setSelectedAd] = useState(null);
  const [editingPost, setEditingPost] = useState(null);

  const handleEditPost = (post) => {
    setSelectedAd(null);
    setEditingPost(post);
  };
  const handlePostUpdated = (updatedPost) => {
    setPosts(prev => prev.map(p => p._id === updatedPost._id ? updatedPost : p));
    setEditingPost(null);
  };
  const handlePostDeleted = (postId) => {
    setPosts(prev => prev.filter(p => p._id !== postId));
    setSelectedAd(null);
  };

  const categories = [
    { id: "all", name: "Todos" },
    { id: "vehicles", name: "Veículos" },
    { id: "electronics", name: "Eletrônicos" },
    { id: "furniture", name: "Móveis" },
    { id: "clothing", name: "Roupas" },
    { id: "sports", name: "Esportes" },
    { id: "games", name: "Games" },
    { id: "home", name: "Casa" },
    { id: "services", name: "Serviços" },
  ];

  const conditions = {
    new: "Novo",
    like_new: "Seminovo",
    used: "Usado",
    for_parts: "Para peças",
  };

  const fetchPosts = async (pageNum = 1) => {
    try {
      let url = `${process.env.REACT_APP_BACKEND_URL}/feed/classified?page=${pageNum}&limit=16`;
      if (category !== "all") url += `&category=${category}`;

      const { data } = await axios.get(url, { headers: { Authorization: `Bearer ${user.token}` } });
      if (pageNum === 1) setPosts(data.posts || []);
      else setPosts((prev) => [...prev, ...(data.posts || [])]);
      setHasMore((data.pagination?.page || 1) < (data.pagination?.pages || 1));
      setLoading(false);
    } catch (error) {
      console.error("Error fetching classified:", error);
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { setPage(1); fetchPosts(1); }, [category]);

  if (loading && posts.length === 0) {
    return <div className="classified_feed_loading"><div className="classified_loader"></div><span>Carregando anúncios...</span></div>;
  }

  return (
    <div className="classified_feed">
      {categories.length > 0 && (
        <div className="simple_filter_bar">
          <div className="filter_buttons">
            {categories.map((filter) => (
              <button
                key={filter.id}
                className={`filter_btn ${category === filter.id ? "active" : ""}`}
                onClick={() => setCategory(filter.id)}
              >
                {filter.name}
              </button>
            ))}
          </div>
        </div>
      )}

      {posts.length === 0 ? (
        <div className="classified_feed_empty">
          <svg viewBox="0 0 24 24" fill="currentColor" width="64" height="64">
            <path d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z"/>
          </svg>
          <h3>Nenhum anúncio encontrado</h3>
          <p>Seja o primeiro a anunciar!</p>
        </div>
      ) : (
        <div className="classified_grid">
          {posts.map((post) => (
            <div key={post._id} className="classified_card" onClick={() => setSelectedAd(post)}>
              <div className="classified_image">
                <img src={post.classifiedData?.images?.[0] || post.images?.[0]?.url || post.images?.[0] || "/images/default-classified.png"} alt="" />
                {post.classifiedData?.featured && (
                  <span className="classified_featured">Destaque</span>
                )}
                {post.classifiedData?.condition && (
                  <span className="classified_condition">{conditions[post.classifiedData.condition]}</span>
                )}
              </div>
              <div className="classified_card_content">
                <h3>{post.classifiedData?.title || post.text}</h3>
                <div className="classified_price_row">
                  <span className="classified_price">
                    R$ {(post.classifiedData?.price || 0).toLocaleString("pt-BR")}
                  </span>
                  {post.classifiedData?.negotiable && (
                    <span className="classified_negotiable">Negociável</span>
                  )}
                </div>
                <div className="classified_meta">
                  <span className="classified_location">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="12" height="12">
                      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
                    </svg>
                    {post.classifiedData?.location || "Não informado"}
                  </span>
                  <span className="classified_date">
                    <Moment fromNow locale="pt-br">{post.createdAt}</Moment>
                  </span>
                  <div onClick={(e) => e.stopPropagation()}>
                    <FeedPostMenu
                      post={post}
                      onEdit={handleEditPost}
                      onPostDeleted={handlePostDeleted}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {hasMore && (
        <div className="classified_load_more">
          <button onClick={() => { setPage(p => p + 1); fetchPosts(page + 1); }} disabled={loading}>
            {loading ? "Carregando..." : "Ver mais anúncios"}
          </button>
        </div>
      )}

      {selectedAd && (
        <div className="classified_modal_overlay" onClick={() => setSelectedAd(null)}>
          <div className="classified_modal" onClick={(e) => e.stopPropagation()}>
            <button className="classified_modal_close" onClick={() => setSelectedAd(null)}>✕</button>

            <div className="classified_modal_gallery">
              <img src={selectedAd.classifiedData?.images?.[0] || selectedAd.images?.[0]} alt="" />
              {selectedAd.classifiedData?.images?.length > 1 && (
                <div className="classified_gallery_nav">
                  {selectedAd.classifiedData.images.map((img, i) => (
                    <div key={i} className="classified_gallery_thumb">
                      <img src={img} alt="" />
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="classified_modal_body">
              <div className="classified_modal_header">
                <div>
                  <span className="classified_modal_category">
                    {categories.find(c => c.id === selectedAd.classifiedData?.category)?.name}
                  </span>
                  <h2>{selectedAd.classifiedData?.title}</h2>
                </div>
                <div className="classified_modal_price">
                  <span>R$ {(selectedAd.classifiedData?.price || 0).toLocaleString("pt-BR")}</span>
                  {selectedAd.classifiedData?.negotiable && (
                    <span className="classified_modal_negotiable">Negociável</span>
                  )}
                </div>
              </div>

              <div className="classified_modal_details">
                <div className="classified_detail_item">
                  <span className="classified_detail_label">Condição</span>
                  <span className="classified_detail_value">{conditions[selectedAd.classifiedData?.condition] || "Não informado"}</span>
                </div>
                <div className="classified_detail_item">
                  <span className="classified_detail_label">Localização</span>
                  <span className="classified_detail_value">{selectedAd.classifiedData?.location || "Não informado"}</span>
                </div>
                <div className="classified_detail_item">
                  <span className="classified_detail_label">Publicado</span>
                  <span className="classified_detail_value">
                    <Moment format="DD/MM/YYYY">{selectedAd.createdAt}</Moment>
                  </span>
                </div>
              </div>

              <div className="classified_modal_desc">
                <h4>Descrição</h4>
                <p>{selectedAd.classifiedData?.description || selectedAd.text}</p>
              </div>

              <Link to={`/profile/${selectedAd.user.username}`} className="classified_seller">
                <img src={selectedAd.user.picture} alt="" />
                <div>
                  <span className="classified_seller_label">Vendedor</span>
                  <span className="classified_seller_name">{selectedAd.user.first_name} {selectedAd.user.last_name}</span>
                </div>
              </Link>

              <div className="classified_modal_actions">
                {selectedAd.classifiedData?.phone && (
                  <a href={`tel:${selectedAd.classifiedData.phone}`} className="classified_phone_btn">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                      <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
                    </svg>
                    Ligar
                  </a>
                )}
                {selectedAd.classifiedData?.whatsapp && (
                  <a href={`https://wa.me/${selectedAd.classifiedData.whatsapp}`} target="_blank" rel="noreferrer" className="classified_whatsapp_btn">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                    </svg>
                    WhatsApp
                  </a>
                )}
                <button className="classified_chat_btn">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                    <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"/>
                  </svg>
                  Chat
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {editingPost && (
        <EditPostPopup
          post={editingPost}
          user={user}
          setVisible={(visible) => !visible && setEditingPost(null)}
          onPostUpdated={handlePostUpdated}
        />
      )}
    </div>
  );
}
